module.exports = __webpack_public_path__ + "static/media/uz.c4be51bb.svg";